import { createBrowserHistory } from 'history';

// eslint-disable-next-line
export const history = createBrowserHistory();
